import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicCreerWOD = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;
  
  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Gestion de votre compétition', link: '/topics/gestion-compet'},
    { label: "Général", link: '/topics/gestion-compet/general'}, 
    { label: topic.title, link: topic.link},
  ]

  // <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/app/dashboard`}>dashboard</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Depuis votre espace
              <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/app/dashboard`}>admin,</a> 
              cliquez sur l'onglet <strong>Workouts.</strong><br/>
              Cette section est divisée en 2 parties : <strong>WOD Scoring</strong> et <strong>WOD Diffusion</strong>
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                Bien que ces deux parties puissent sembler similaires, elles remplissent des fonctions bien distinctes :
              </p>
              <ul>
                <li className="pl-8 mb-24">
                  <p className="help-text mb-8">
                    <strong className="mr-8">WOD Scoring :</strong>
                    Cette section vous permet de créer vos WODs, qui seront uniquement utilisés pour intégrer les scores et 
                    alimenter le leaderboard. Lorsque vos athlètes consulteront le leaderboard, ils y verront le 
                    classement basé sur les WODs que vous aurez configurés ici.
                  </p>
                  <p className="help-text">
                    <i className="bi bi-info-circle fz-18 mr-8"></i>Si vous souhaitez diviser un même WOD en plusieurs avec 
                    plusieurs classements distincts, il vous suffit de créer plusieurs WODs scoring.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text mb-8">
                    <strong className="mr-8">WOD Diffusion :</strong>
                    Cette section vous permet de publier la description et les détails des WODs pour vos athlètes. 
                    Vous avez également la possibilité d'importer une image, tout comme lorsque vous les diffusez 
                    sur vos réseaux sociaux.
                  </p>
                  <p className="help-text">
                    <i className="bi bi-info-circle fz-18 mr-8"></i>Si un WOD est divisé en plusieurs WODs Scoring, cette section vous permet 
                    de les regrouper en un seul, pour une présentation et une gestion simplifiées.
                  </p>
                </li>
              </ul>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <div className="sub-article-container">
                <p className="help-text mb-8"><strong>Infos principales</strong></p>
                <ul>
                  <li className="pl-8 mb-8">
                    <p className="help-text">
                      Saisissez le nom du WOD 
                      <span className="fz-14 ml-8 op-9 fw-400">(par exemple, <i className="mr-4">"WOD 1 - Warming-up"</i> ou <i className="ml-4">"WOD 1a"</i> )</span>
                    </p>
                  </li>
                  <li className="pl-8 mb-8">
                    <p className="help-text">
                      Time Cap au format HH:mm:ss. Ne saisissez seulement les chiffres. <br />
                      <span className="fz-14 op-9 fw-400">(par exemple 00:14:00)</span>
                    </p>
                  </li>
                  <li className="pl-8 mb-8">
                    <p className="help-text">
                      Ordre du WOD. Si un WOD est divisé en plusieurs parties <span className="fz-14 op-9 fw-400">(par exemple, WOD 1A et WOD 1B)</span>, 
                      utilisez le même numéro pour chacune afin de les regrouper correctement.
                    </p>
                  </li>
                </ul>
              </div>
              <div className="sub-article-container mt-32">
                <p className="help-text mb-8"><strong>Pour qui ?</strong></p>
                <p className="help-text">
                  Cochez la ou les les catégories concernées par le WOD que vous configurez pour indiquer à quels athlètes 
                  il s'applique.
                </p>
              </div>
              <div className="sub-article-container mt-32">
                <p className="help-text mb-8"><strong>Scoring</strong></p>
                <p className="help-text mb-4">
                  C'est ici que vous allez définir le type de WOD <span className="fz-14 op-9 fw-400">(AMRAP, FOR TIME...)</span>.
                </p>
                <p className="help-text">
                  Configurez jusqu'à 3 scores pour départager vos athlètes. <br/>
                  Voici comment cela fonctionne : les athlètes 
                  sont d'abord classés selon leur 1er score. En cas d'égalité, le second score est utilisé pour les 
                  départager. Si l'égalité persiste, le 3e score sera pris en compte.
                  <span className="fz-14 op-9 fw-400 ml-8">(Exemple : For Time / Reps / Tie Break)</span>
                </p>
                <p className="help-text">
                  <strong className="mr-8">NB :</strong>
                  Seul le 1er score est obligatoire. Les 2e et 3e scores sont facultatifs.
                </p>
              </div>
              <div className="sub-article-container mt-40">
                <p className="help-text mb-8"><strong>Distribution des points</strong></p>
                <p className="help-text mb-4">
                  Vous disposez de plusieurs options pour attribuer des points aux athlètes en fonction de leur classement :
                </p>
                <ul>
                  <li className="pl-8 mb-16">
                    <p className="help-text mb-4">
                      <span className="fz-14 op-9 fw-600 mr-8">Coef : </span>
                      Attribuez les points en définissant un coefficient, qui détermine l'écart entre deux positions.&nbsp;&nbsp;
                      <span className="fz-14 op-9 fw-400">
                        (Par exemple, avec un coefficient de 5, le 1er obtient 100 points, le 2e 95, le 3e 90, etc.)
                      </span>
                    </p>
                  </li>
                  <li className="pl-8 mb-16">
                    <p className="help-text mb-4">
                      <span className="fz-14 op-9 fw-600 mr-8">Point attribué par score : </span>
                      Attribuez X points au classement général en fonction des reps du WOD. Par exemple, 
                      pour un WOD optionnel (course de 5 km), chaque participant de l’équipe qui y participe 
                      rapporte 5 points au classement général.
                    </p>
                  </li>
                  <li className="pl-8 mb-16">
                    <p className="help-text mb-4">
                      <span className="fz-14 op-9 fw-600 mr-8">Max point : </span>
                      Permet d'attribuer un nombre de point précis au vainqueur du WOD. Les autres points seront 
                      attribués automatiquement de façon dégressives aux autres athlètes.
                    </p>
                  </li>
                </ul>
              </div>
              <div className="sub-article-container mt-32">
                <p className="help-text mb-8"><strong>Ce WOD a un score qui s'additionne entre athlètes</strong></p>
                <p className="help-text mb-4">
                  Activez cette option si le score final de ce WOD résulte de la somme de plusieurs résultats.
                  <span className="fz-14 op-9 fw-400">
                    &nbsp;(Par exemple : Max tonnage de l'Athlète A + Max tonnage de l'Athlète B. Le score total sera alors calculé automatiquement.)
                  </span>
                </p>
                <p className="help-text mb-4">
                  Vous pouvez égelement ajouter un coefficient de score si besoin, ou même d'ajouter un autre score combiné.
                </p>
              </div>
              <div className="sub-article-container mt-40">
                <p className="help-text mb-8"><strong>Places limitées</strong></p>
                <p className="help-text mb-4">
                  Activez cette option si ce WOD ne conserne pas tous les participants de la catégorie. 
                  Indiquez le nombre d'athlete qui participeront à ce WOD.<br/>
                  <span className="fz-14 op-9 fw-400">
                    (Par exemple dans le cas d'une finale où seul les X premiers athlètes sont qualifiés.)
                  </span>
                </p>
              </div>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part">{anchorsParts[2].content}</p>
              <div className="sub-article-container">
                <p className="help-text mb-8"><strong>Infos principales</strong></p>
                <ul>
                  <li className="pl-8 mb-8">
                    <p className="help-text">
                      Saisissez le nom du WOD 
                      <span className="fz-14 ml-8 op-9 fw-400">(par exemple, <i className="mr-4">"WOD 1 - Warming-up"</i>)</span>
                    </p>
                  </li>
                  <li className="pl-8 mb-8">
                    <p className="help-text">
                      Type de WOD <span className="fz-14 op-9 fw-400">(AMRAP, FOR TIME ...)</span>
                    </p>
                  </li>
                  <li className="pl-8 mb-8">
                    <p className="help-text">
                      Ordre du WOD
                    </p>
                  </li>
                </ul>
              </div>
              <div className="sub-article-container mt-32">
                <p className="help-text mb-8"><strong>Diffusion du WOD</strong></p>
                <p className="help-text">
                  Choisissez de publier immédiatement le WOD à vos athlètes ou planifiez sa diffusion en saisissant 
                  une date et une heure spécifiques.
                </p>
              </div>
              <div className="sub-article-container mt-32">
                <p className="help-text mb-8"><strong>Description du WOD</strong></p>
                <p className="help-text">
                  Saisissez tout d'abord le nom de la catégorie n°1.
                  <span className="fz-14 op-9 fw-400">&nbsp;&nbsp;(Par exemple : Master / Inter)</span><br/>
                  Si la description est commune à toute les catégories, remplisser "All".
                </p>
                <p className="help-text mb-4 mt-24">
                  Ajouter le contenu du WOD. Pour cela 2 solutions :
                </p>
                <ul className="mt-0">
                  <li className="pl-8 mb-8">
                    <p className="help-text">Importer une photo comme sur vos réseaux</p>
                  </li>
                  <li className="pl-8 mb-8">
                    <p className="help-text">Saisissez votre description via notre éditeur de texte</p>
                  </li>
                </ul>
                <p className="help-text mb-4 mt-24">
                  Détails :&nbsp;&nbsp;Si votre description ou image a besoin d'informations supplémentaires.
                  <span className="fz-14 op-9 fw-400">&nbsp;&nbsp;(Par exemple : le détail du scoring)</span>
                </p>
                <p className="help-text mb-4 mt-24">
                  Time Cap au format HH:mm:ss. Ne saisissez seulement les chiffres. <br />
                  <span className="fz-14 op-9 fw-400">(par exemple 00:14:00)</span>
                </p>
                <p className="help-text mb-4 mt-40">
                  Besoin d'ajouter une nouvelle description / image pour une autre catégorie ? Cliquer simplement
                  sur le bouton <strong>Ajouter une variation / catégorie</strong>
                </p>
              </div>
              <div className="article-container mt-56" ref={anchorsParts[3].ref}>
                <p className="help-title-part">{anchorsParts[3].content}</p>
                <p className="help-text">
                  Une fois tous les champs renseignés, cliquez sur le bouton <strong>Enregister le WOD</strong>.
                </p>
                <p className="help-text">
                  Pour modifier un WOD déjà créé, cliquez simplement sur son nom dans la barre latérale, 
                  apportez les ajustements nécessaires, puis cliquez sur le bouton <strong>Mettre à jour le WOD</strong>.
                </p>
              </div>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicCreerWOD 